export default __webpack_public_path__ + "static/media/successful-sign-up.c27b6a30.gif";